<template functional>
    <thead class="ut-text-neutral-400">
        <tr class="ut-font-semibold ut-text-neutral-400">
            <th class="ut-py-6">Address</th>
            <th class="ut-pl-3">Vendor</th>
            <th class="ut-pl-3">Phone</th>
            <th class="ut-pl-3">Other agents</th>
            <th class="ut-pl-3">Referred</th>
            <th class="ut-pl-3">Agent</th>
            <th>Status</th>
        </tr>
    </thead>
</template>

<script>
export default {
  name: 'LeadCohortsTableHead',
};
</script>

<style lang="scss" scoped>
</style>
